import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";

import { ScheduleRulesTable } from "./scheduleRulesTable/ScheduleRulesTable";
import { Desktop, TabletMobile } from "../../../../../common/Responsive";
import { ScheduleRulesCards } from "./scheduleRulesCards/ScheduleRulesCards";
import { useSchedulerContext } from "../../SchedulerContext";

import { AddScheduleRuleButton } from "../addScheduleRuleButton/AddScheduleRuleButton";
import { getProfileSchedulesByType } from "../../../../../store/schedules";

import "./ScheduleRules.scss";

export const ScheduleRules = () => {
  const { maxSchedulesCount, profileId, type } = useSchedulerContext();
  const schedules = useSelector(getProfileSchedulesByType(profileId, type));

  return (
    <div className="schedule-rules">
      <div className={"schedule-rules__header"}>
        <div className={"schedule-rules__title"}>
          <h3 aria-describedby={"rules-count-description"}>
            <FormattedMessage id={"rules"} />
          </h3>
          <span hidden aria-hidden={true} id={"rules-count-description"}>
            <FormattedMessage
              id={"rules_count_aria"}
              values={{
                count: schedules.length,
                limit: maxSchedulesCount,
                isLimitReached: schedules.length === maxSchedulesCount,
              }}
            />
          </span>
          <span className={"counter"} aria-hidden={true}>
            (<span>{schedules.length}</span>/<span>{maxSchedulesCount}</span>)
          </span>
        </div>
        <AddScheduleRuleButton />
      </div>
      <TabletMobile>
        <ScheduleRulesCards schedules={schedules} />
      </TabletMobile>
      <Desktop>
        <ScheduleRulesTable schedules={schedules} />
      </Desktop>
    </div>
  );
};
